module.exports = __webpack_public_path__ + "img/expostyle_1129_prune_pantone7657c.3fcf1bab.jpg";